import React from 'react';
import MiActividad from '../actividad/MiActividad';
export default function Comisiones(){return <MiActividad inicial="comisiones"/>;}
